/**
 * Extract printable ASCII runs of at least `minLen` characters from raw bytes.
 */
export function extractStrings(bytes: Uint8Array, minLen = 5): string[] {
  const results: string[] = [];
  let current = '';

  for (let i = 0; i < bytes.length; i++) {
    const b = bytes[i];
    if (b >= 32 && b <= 126) {
      current += String.fromCharCode(b);
    } else {
      if (current.length >= minLen) {
        results.push(current);
      }
      current = '';
    }
  }

  if (current.length >= minLen) {
    results.push(current);
  }

  return results;
}
